import { useState } from 'react';

// @mui material components
import Icon from '@mui/material/Icon';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';

// Material Dashboard 2 PRO React components
import MDBox from 'components/MDBox';

// Project components
import ProductionsData from '../ProductionsData';
import ProductionsKanban from '../KanbanView';
import ProductionsReports from '../Reports';
import Summary from '../Summary';

function ViewToggle() {
    const [currentView, setCurrentView] = useState(0);
    const [showSummary, setShowSummary] = useState(false);

    const handleViewChange = (event, newValue) => {
        setCurrentView(newValue);
    };

    const toggleSummary = () => {
        setShowSummary(!showSummary);
    };

    return (
        <MDBox>
            <MDBox display="flex" justifyContent="space-between" alignItems="center" mt={1} mb={3}>
                <Tabs
                    value={currentView}
                    onChange={handleViewChange}
                    sx={{ flexGrow: 1, display: 'flex', justifyContent: 'center' }}
                >
                    <Tab
                        label="Kanban Görünümü"
                        icon={
                            <Icon fontSize="small" sx={{ mt: -0.25 }}>
                                view_kanban
                            </Icon>
                        }
                    />
                    <Tab
                        label="Tablo Görünümü"
                        icon={
                            <Icon fontSize="small" sx={{ mt: -0.25 }}>
                                table_view
                            </Icon>
                        }
                    />
                    <Tab
                        label="Raporlar"
                        icon={
                            <Icon fontSize="small" sx={{ mt: -0.25 }}>
                                assessment
                            </Icon>
                        }
                    />
                </Tabs>
                <Tooltip title={showSummary ? 'Özet raporları gizle' : 'Özet raporları göster'}>
                    <IconButton onClick={toggleSummary} color={showSummary ? 'primary' : 'default'} size="large">
                        <Icon>dashboard</Icon>
                    </IconButton>
                </Tooltip>
            </MDBox>

            {showSummary && (
                <MDBox mb={3}>
                    <Summary />
                </MDBox>
            )}

            <MDBox>
                {currentView === 0 && <ProductionsKanban />}
                {currentView === 1 && <ProductionsData />}
                {currentView === 2 && <ProductionsReports />}
            </MDBox>
        </MDBox>
    );
}

export default ViewToggle;
